__turbopack_context__.v({
  "button": "AppFooter-module__UWX7cG__button",
  "footerContainer": "AppFooter-module__UWX7cG__footerContainer",
  "footerGroup": "AppFooter-module__UWX7cG__footerGroup",
});
